import { usePermissions } from "components/context/permissionsContext";

export const useInventoryPermission = () => {
  const { userPermissions } = usePermissions();

  // Asset Permissions
  const hasAssetSavePermission = userPermissions.some(
    (item) =>
      item.module === "Inventory" &&
      item.controller === "Asset" &&
      item.action === "Save" &&
      item.hasPermission
  );
  const hasAssetGetPermission = userPermissions.some(
    (item) =>
      item.module === "Inventory" &&
      item.controller === "Asset" &&
      item.action === "Get" &&
      item.hasPermission
  );
  const hasAssetDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Inventory" &&
      item.controller === "Asset" &&
      item.action === "Delete" &&
      item.hasPermission
  );

  // Material Permissions
  const hasMaterialSavePermission = userPermissions.some(
    (item) =>
      item.module === "Inventory" &&
      item.controller === "Material" &&
      item.action === "Save" &&
      item.hasPermission
  );
  const hasMaterialGetPermission = userPermissions.some(
    (item) =>
      item.module === "Inventory" &&
      item.controller === "Material" &&
      item.action === "Get" &&
      item.hasPermission
  );
  const hasMaterialDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Inventory" &&
      item.controller === "Material" &&
      item.action === "Delete" &&
      item.hasPermission
  );

  // Asset & Material Type Permissions
  const hasTypeCatalogSavePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "TypeCatalog" &&
      item.action === "Save" &&
      item.hasPermission
  );
  const hasTypeCatalogGetPermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "TypeCatalog" &&
      item.action === "Get" &&
      item.hasPermission
  );
  const hasTypeCatalogDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Settings" &&
      item.controller === "TypeCatalog" &&
      item.action === "Delete" &&
      item.hasPermission
  );

  const InventoryPermissionProps = {
    // Asset Permissions
    hasAssetSavePermission,
    hasAssetGetPermission,
    hasAssetDeletePermission,

    // Material Permissions
    hasMaterialSavePermission,
    hasMaterialGetPermission,
    hasMaterialDeletePermission,

    // Asset & Material Type Permissions
    hasTypeCatalogSavePermission,
    hasTypeCatalogGetPermission,
    hasTypeCatalogDeletePermission,
  };

  return {
    InventoryPermissionProps,
  };
};
